import React from 'react'
import { Plus, PlusCircle, RefreshCcw, Search } from 'react-feather'
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { searchProductos, startloadProductos } from '../../../../app/store/catalagos/thunks';
import Swal from 'sweetalert2';
import { useState } from 'react';
import { Table } from '../../../pages/inventory/components/tables/Table';
import { product_status, status_colors } from '../../../pages/inventory/app/Constants';

export const SearchProd = ({ handledAddProduct }) => {

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
        didOpen: (toast) => {
            // toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    const dispatch = useDispatch();
    const { categoriasAlm, marcasAlm, proveedoresAlm, productosAlm, productosAlmEdit, isLoading } = useSelector(state => state.catalogos);

    const { register, reset, formState: { errors }, handleSubmit } = useForm({
        defaultValues: {
            textSearch: "",
            param: "1"
        }
    });

    // const handledSearch = (data) => {
    //     dispatch(searchProductos(data));
    // }
    // const handledsearchGeneral = () => {
    //     reset();
    //     dispatch(startloadProductos());
    // }

    const listProductos = productosAlm.filter(
        item => item.TYPE_PRODUCT !== "2"
    );


    if (isLoading) {
        return (
            <>
                <div className='div_center'>
                    <div className='text-center'>
                        <div className="spinner"></div>
                    </div>
                    <div className='text-center text-left-15'>
                        <span className='fw-bold'>Cargando</span>
                    </div>
                    <div className='text-center text-left-15'>
                        <div className="spinner"></div>
                    </div>
                </div>
            </>
        )
    }


    let columnsProducts = [
        {
            header: 'ACCIONES',
            dataIndex: 'ACTIVE',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value, row) => {
                const isDeleted = Number(row.ACTIVE) === 0;
                return (
                    <div className="btn-group border-0" role="group">
                        <button type="button" className="btn btn-outline-primary" onClick={() => handledAddProduct(row.ID)} ><PlusCircle size='20' /></button>
                    </div>
                );
            }
        },
        {
            header: 'SKU',
            dataIndex: 'SKU',
            classHeader: 'text-start',
            classRow: 'text-start',
            // renderer: (value, row) => (
            //     <>
            //         <button type="button" className="btn btn-link" onClick={() => { setSelectedItem(row.SKU); navigateTo('edit', { sku: row.SKU }); }} >{value}</button>
            //     </>
            // ),
        },
        {
            header: 'CATEGORIA',
            dataIndex: 'NAMECATEGORY',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'MARCA',
            dataIndex: 'NAMEBRAND',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'PRODUCTO',
            dataIndex: 'NAME_PRODUCT',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'DESCRIPCION',
            dataIndex: 'DESCRIPTION_PRODUCT',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'EXISTENCIAS',
            dataIndex: 'CURRENTSTOCK',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'COSTO',
            dataIndex: 'PURCHASE_PRICE',
            classHeader: 'text-end',
            classRow: 'text-end',
            renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
        },
        {
            header: 'PRECIO',
            dataIndex: 'SALE_PRICE',
            classHeader: 'text-end',
            classRow: 'text-end',
            renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
        },
        {
            header: 'ESTADO',
            dataIndex: 'ACTIVE',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value) => {
                const code = Number(value);
                return (
                    <span className={`badge ${status_colors[code]}`}>
                        {product_status[code]}
                    </span>
                );
            }
        },
        {
            header: 'ACCIONES',
            dataIndex: 'ACTIVE',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value, row) => {
                const isDeleted = Number(row.ACTIVE) === 0;
                return (
                    <div className="btn-group border-0" role="group">
                        <button type="button" className="btn btn-outline-primary" onClick={() => handledAddProduct(row.ID)} ><PlusCircle size='20' /></button>
                    </div>
                );
            }
        }
    ];

    const products = [...listProductos];



    return (
        <div className='p-1 mt-1'>
            <Table
                columns={columnsProducts}
                data={products}
                function_={(row) => { console.log(''); }}
                placeholderSearch="Buscar por: SKU, Codigo de Barra, Nombre, Descripcion, Tipo"
                showPagination={false}
                showControls={true}
                showTotals={false}
            />

        </div>
    )
}
